import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AclDataModule } from '../acl-data/acl-data.module';
import { AngularMaterialModule } from '../angular-material.module';
import { DocumentViewsModule } from '../document-views/document-views.module';
import { SharedControlsModule } from '../shared-controls/shared-controls.module';
import { DocumentAddComponent } from './document-add/document-add.component';
import { DocumentUploadSelectComponent } from './document-upload-select/document-upload-select.component';
import { DuplicateCheckComponent } from './duplicate-check/duplicate-check.component';
import { AclSearchModule } from '../acl-search/acl-search.module';

@NgModule({
    declarations: [
        DocumentAddComponent,
        DocumentUploadSelectComponent,
        DuplicateCheckComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AclDataModule,
        AngularMaterialModule,
        PdfViewerModule,
        FileUploadModule,
        SharedControlsModule,
        DocumentViewsModule,
        NgxMatSelectSearchModule,
        RouterModule.forChild([]),
        AclSearchModule,
    ],
})
export class DocumentAddModule {}
